function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffaf00}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M341.3 88.5a40.7 40.7 0 1070.4 40.8 40.7 40.7 0 00-70.4-40.8zm17.3 10a20.6 20.6 0 0128.4-7.6 20.9 20.9 0 01-5 38.1 20.8 20.8 0 01-23.4-30.5zM179.6 184.1c0 5.5 4.5 10 10 10s10-4.5 10-10a10 10 0 00-10-10 10 10 0 00-10 10z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4 391.2a70.7 70.7 0 0033.1 43.1l119.7 69.1a56.2 56.2 0 0077-20.6l2.5-4.3 12.5 7.2a57.2 57.2 0 0078.4-21l163.6-283.3a60.2 60.2 0 003.4-52.8L456.4 23.2A37.9 37.9 0 00416.8.3L303.4 14.8a60 60 0 00-43 27.6l-60.3 7.7a37.1 37.1 0 00-27.2 18.1L17.5 337.3a70.6 70.6 0 00-7.1 53.9zm24.4-43.9L190.2 78.2c2.6-4.5 7.3-7.6 12.5-8.3l45.2-5.8-45.4 78.6a9.9 9.9 0 003.7 13.6 9.9 9.9 0 0013.6-3.7l56.9-98.5A40 40 0 01306 34.6l113.3-14.5c7.9-1 15.6 3.4 18.7 10.8l44.1 105.4a40.1 40.1 0 01-2.2 35.1L316.3 454.7a37.4 37.4 0 01-51.1 13.7l-21.1-12.2-117.3-67.7a37.5 37.5 0 01-13.7-51.1l65.3-113.1a9.9 9.9 0 00-3.7-13.6 9.9 9.9 0 00-13.6 3.7l-65.3 113-.2.3v.1a57 57 0 0018 75.9l.3.2.5.3h.1l2.4 1.5 108.7 62.7-2.5 4.3a36.3 36.3 0 01-49.7 13.4L53.5 417a50.8 50.8 0 01-18.7-69.7z"
});

var SvgTag = function SvgTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 511 511",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tag.be7e1131.svg";
export { ForwardRef as ReactComponent };